<template>
  <div class="intro1">
    <div class="intro1-tit">
      <div class="wl"></div>
      <span>开设院校</span>
    </div>
    <v-serchmy @search="searchName" placeholder="请输入您想查询的院校"></v-serchmy>
    <div class="intro1_r">
      <!-- <dl v-for="college in data">
        <dt>
          <img style="border-radius: 40px;"
            :src="($resourcesUrl+'/college/'+`${college.collegeId}`+'/'+`${college.collegeIcon}`)">
          <div class="trxt">
            <span>
              <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+college.collegeId">
                {{college.collegeName}}
              </router-link>
              <icollege :item="college"></icollege>
            </span>
            <span>{{college.collegeLevel}}</span>
          </div>
        </dt>
        <dd>
          <div class="dd_l">
            <li class="dd_l1">
              <span>{{AREA_OBJ[college.collegeArea]}}</span>
              <img src="../../../assets/img/dengweihui.png">
            </li>
            <li class="dd_l2">
              <span>{{college.collegeRank}}</span>
              <span>院校排名：</span>
            </li>
          </div>
          <div class="dd_r">
            <span @click="xueshengjianjie(4,college)">院校分数线</span>
            <span @click="toluqulv(college)">测试录取率</span>
          </div>
        </dd>
        <img src="../../images/home/starA.png" class="dingweisde" v-if="userCang.indexOf(college.collegeId)!=-1">
        <img src="../../images/home/star.png" class="dingweisde" v-else>
      </dl> -->
      <collegeList :list="data" :guding="guding" :userCang="userCang" @shou="shou"></collegeList>
    </div>
  </div>
</template>

<script>
  import vSerchmy from '../../../components/vSerchmy.vue'
  import icollege from '../../../components/icollege.vue'
  import collegeList from '../collegelist.vue'

  export default {
    name: "",
    components: {
      vSerchmy,
      icollege,
      collegeList
    },
    props: ['id'],
    data() {
      return {
        data: [],
        userCang: [],
        queryObj: {collegeName:''},
        pageSize: 10,
        pageNum: 1,
        total: 0,
        loadding: false,
        AREA_OBJ: this.$utils.getlocalStorage('AREA_OBJ'),
        guding:false
      }
    },
    created() {
      let userCang = this.$utils.getlocalStorage('userCang')
      if (userCang != null && userCang != '') {
        this.userCang = userCang.college
      }
      this.getcollegeData()
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      shou(id) {
      	let _this = this;
      	let flag1 = this.$utils.getLoginStatus();
      	if (flag1) {
      		let obj = this.$utils.getlocalStorage('userCang')
      		let list = obj.college
      		if (list.indexOf(id) == -1) {
      			_this.$req.insert("collectionTable", {
      				dataType: 1,
      				dataId: id,
              userId:this.$utils.getlocalStorage('userInfo').userId
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.push(id);
      					_this.userCang = list
      					obj.college = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})

      		} else {
      			_this.$req.batchDelete("collectionTable", {
      				data_type: 1,
      				data_id: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.splice(list.indexOf(id), 1);
      					_this.userCang = list
      					obj.college = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      		}
      	}
      },
      searchName(name) {
        this.data = [];
        this.pageNum = 1;
        this.total= 0;
        this.queryObj.collegeName = name
        this.getcollegeData()
      },
      getcollegeData() {
        let _this = this;
        if (this.loadding) {
          return;
        }
        this.loadding = true;
        this.queryObj.collegeId = this.id
        this.$req.queryAllByLimitByMajor({
          pageSize: _this.pageSize,
          pageNum: _this.pageNum,
          queryObj: this.queryObj
        }).then(function(response) {
          _this.data = _this.data.concat(response.data)
          _this.total = response.pages;
          _this.loadding = false;
        })
      },
      // 操作
      xueshengjianjie(obg, college) {
        if (obg == 4) {
          if (this.$utils.tologin(this)) {
            if (this.$utils.getUserInfo(this)) {
              if (this.$utils.getFenshu(this)) {
                this.$utils.setlocalStorage("collegeInfo", college);
                // this.$router.push('/xyzy_jianjie?num='+obg)
                let routeUrl = this.$router.resolve({
                  path: "/xyzy_jianjie",
                  query: {
                    num: obg,
                    id: college.collegeId
                  }
                });
                window.open(routeUrl.href, '_blank')
              }
            }
          }
        } else {
          this.$utils.setlocalStorage("collegeInfo", college);
          // this.$router.push('/xyzy_jianjie?num='+obg)
          let routeUrl = this.$router.resolve({
            path: "/xyzy_jianjie",
            query: {
              num: obg,
              id: college.collegeId
            }
          });
          window.open(routeUrl.href, '_blank')
        }

      },
      toluqulv(college) {
        if (this.$utils.tologin(this)) {
          if (this.$utils.getUserInfo(this)) {
            if (this.$utils.getFenshu(this)) {
              this.$router.push('/cegailv?collegeName=' + college.collegeName)
            }
          }

        }

      },
      handleScrollx(e) {
        const scrollY =
          document.body.scrollTop || document.documentElement.scrollTop; // 滚动条在Y轴上的滚动距离
        const compatibility =
          document.compatMode === "CSS1Compat" ?
          document.documentElement.clientHeight :
          document.body.clientHeight;

          let tedItem = document.querySelector("#yuanshu1")
          let tedItem2 = document.querySelector("#yuanshu2")
          var scrollTop1 = tedItem.getBoundingClientRect().top
          var scrollTop2 = tedItem2.getBoundingClientRect().top
          console.log(scrollTop1)
          console.log(scrollTop2)
          if (scrollTop1 <= 100) {
            this.guding = true
          }
          if (scrollTop2 >= 200) {
            this.guding = false
          }
          console.log(this.guding)


        // clientHeight 属性是一个只读属性，它返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条，是一个整数，单位是像素 px。
        // 页面总高度
        const TotalHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );
        // 当滚动条滑到页面底部
        if (compatibility + scrollY >= (TotalHeight - 800)) {

          if (this.pageNum < this.total && !this.loadding) {
            this.pageNum++;
            this.getcollegeData()

          }
        }

      },

    }


  }
</script>

<style scoped>
  .intro1 {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .intro1-tit {
    margin-bottom: 15px;
  }

  .intro1-tit span {
    margin-left: 10px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    display: flex;
    align-items: center;
  }

  .wl {
    width: 6px;
    height: 22px;
    border-radius: 0px 4px 4px 0px;
    background: #F21323;
  }

  .intro1-tit {
    display: flex;
  }

  .intro1_r {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .intro1_r dl {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    box-sizing: border-box;
    width: 100%;
    height: 118px;
    border: 1px solid #F1F1F1;
    background: linear-gradient(90deg, #EEFFFE 0%, #FFFFFF 100%);
    opacity: 1;
    border-radius: 10px;
  }

  .intro1_r dl dt {
    display: flex;
    align-items: center;
  }

  .intro1_r dl dt img {
    height: 70px;
    margin-right: 10px;
  }

  .intro1_r dl dt .trxt {
    display: flex;
    flex-direction: column;
    height: 70px;
    justify-content: space-between;
  }

  .intro1_r dl dt .trxt span:nth-of-type(1) {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .intro1_r dl dt .trxt span:nth-of-type(2) {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .intro1_r dl dd {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 45px;
  }

  .dd_l {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 15px;
    box-sizing: border-box;
    justify-content: space-between;
    border-right: 1px solid rgba(0, 0, 0, 0.10196078431372549);
  }

  .dd_l li {
    display: flex;
    text-align: right;
    flex-direction: row-reverse
  }

  .dd_l li img {
    height: 14.2px;
    margin-right: 15px;
  }

  .dd_l1 {
    display: flex;
    align-items: center;
  }

  .dd_l1 span {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .dd_l2 span:nth-of-type(2) {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .dd_l2 span:nth-of-type(1) {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F41325;
  }

  .dd_r {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-left: 15px;
    box-sizing: border-box;
  }

  .dd_r span:nth-of-type(1) {
    margin-bottom: 5px;
    width: 100px;
    height: 34px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #29A7E1;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dd_r span:nth-of-type(2) {
    width: 100px;
    height: 34px;
    background: rgba(244, 19, 37, 1);
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .dingweisde {
    width: 32px;
    height: 37px;
    position: absolute;
    top: 0;
    right: 20px;
  }

  .container {
    width: 1485px;
  }

  @media (max-width:750px) {
    .container {
      width: auto;
    }

    .intro1_r {
      overflow-x: auto;
      overflow-y: hidden;
    }

    .intro1_r dl {
      width: 900px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/information/majorinfo/kaisheyuanxiao.vue